<template>
  <filter-template @submit="filter()">
    <v-row class="pt-6">
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <input-select
              id="input:Status"
              v-model="payload.Status"
              label="Status"
              :items="statusOptions"
              clearable
            />
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="12">
            <span>Data da criação</span>
            <v-row class="pt-2">
              <v-col cols="6">
                <input-date
                  id="input:MinCreatedAt"
                  v-model="payload.MinCreatedAt"
                  :rules="[dateLesserThan(payload.MaxCreatedAt)]"
                  label="Inicial"
                />
              </v-col>
              <v-col cols="6">
                <input-date
                  id="input:MaxCreatedAt"
                  v-model="payload.MaxCreatedAt"
                  :rules="[dateGreaterThan(payload.MinCreatedAt)]"
                  label="Final"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col
            cols="12"
            class="pt-6"
          >
            <span>Data da cobrança</span>
            <v-row class="pt-2">
              <v-col cols="6">
                <input-date
                  id="input:MinDate"
                  v-model="payload.MinDate"
                  :rules="[dateLesserThan(payload.MaxDate)]"
                  label="Inicial"
                />
              </v-col>
              <v-col cols="6">
                <input-date
                  id="input:MaxDate"
                  v-model="payload.MaxDate"
                  :rules="[dateGreaterThan(payload.MinDate)]"
                  label="Final"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="pt-6"
          >
            <input-money
              id="input:Amount"
              v-model="payload.Amount"
              label="Valor da cobrança"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="pt-6"
          >
            <input-text
              id="input:Nsu"
              v-model="payload.Nsu"
              label="NSU"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="pt-6"
          >
            <input-mask
              id="input:Document"
              v-model="payload.Document"
              label="Documento"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="pt-6"
          >
            <input-select
              id="input:PaymentMethodType"
              v-model="payload.PaymentMethodType"
              label="Modalidade"
              :items="methodsTypes"
              clearable
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </filter-template>
</template>

<script>
import FilterMixin from '@/app/arch/components/crud/crud-mixins/FilterMixin';
import FilterTemplate from '@/app/arch/components/crud/components/FilterTemplate.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import BillingStatus from '@/app/arch/enums/BillingStatus';

export default {
  name: 'CardBillingFilter',
  components: { FilterTemplate },
  mixins: [FilterMixin, RulesMixin],
  data: () => ({
    statusOptions: BillingStatus,
    methodsTypes: [
      {
        text: 'Crédito',
        value: 'CreditCard',
      },
      {
        text: 'Débito',
        value: 'DebitCard',
      },
    ],
    payload: {
      MinDate: '',
      MaxDate: '',
      Amount: '',
      Status: '',
      MaxCreatedAt: '',
      MinUpdatedAt: '',
      Nsu: '',
      PaymentMethodType: '',
      Document: '',
    },
  }),
  methods: {
    preparePayload() {
      const { Document, ...rest } = this.payload;
      return {
        Document: String(Document).replace(/[^0-9]/g, ''),
        ...rest,
      };
    },
  },
};
</script>
